import { ImageObject } from 'schema-dts';
import { siteUrl } from '..';
import { MetaProps } from '../../../../types/IHeader';
import { PostMeta } from '../../utils';

export const primaryImage = (
  data: MetaProps,
  uri: string,
  postMeta: PostMeta,
): ImageObject | null => {
  const isBlogArticle = data.__typename === 'DatoCmsBlogArticle';

  try {
    // Get page-specific image data
    const metaImage = data?.metaFields?.image;
    const heroImage = data?.hero?.[0]?.image;

    // For blog articles, use page-specific images
    const pageImage = isBlogArticle ? metaImage || heroImage : undefined;

    // Get fallback image
    const fallbackImage = postMeta?.fallbackSeoImage;

    // Determine final values
    const url = pageImage?.url || fallbackImage?.src;
    const width =
      pageImage?.width?.toString() || fallbackImage?.height?.toString();
    const height =
      pageImage?.height?.toString() || fallbackImage?.height?.toString();

    return {
      '@id': `${siteUrl}${uri}#primaryimage`,
      '@type': 'ImageObject',
      url,
      contentUrl: url,
      width,
      height,
      name: data?.metaFields?.title || '',
    };
  } catch (error) {
    console.error('Error in primaryImage:', error);
    return null;
  }
};
